var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-deselect" }, [
    _c(
      "svg",
      {
        attrs: {
          width: "12",
          height: "12",
          viewBox: "0 0 12 12",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
      },
      [
        _c("path", {
          attrs: {
            d: "M1.2553 11.707C0.864771 11.3164 0.864771 10.6833 1.2553 10.2927L10.2928 1.25383C10.6833 0.863306 11.3165 0.863307 11.707 1.25383C12.0975 1.64436 12.0975 2.27752 11.707 2.66804L2.66951 11.707C2.27898 12.0975 1.64582 12.0975 1.2553 11.707Z",
            fill: "#FF238D",
          },
        }),
        _c("path", {
          attrs: {
            d: "M11.6132 11.6445C12.0038 11.254 12.0038 10.6208 11.6132 10.2303L2.63679 1.25383C2.24627 0.863306 1.6131 0.863307 1.22258 1.25383C0.832056 1.64436 0.832056 2.27752 1.22258 2.66804L10.199 11.6445C10.5896 12.035 11.2227 12.035 11.6132 11.6445Z",
            fill: "#FF238D",
          },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }